import 'shared/trackjs'
import Modernizr from 'modernizr'
import { googleAnalyticsEvent } from 'shared/util/analytics'
import renderMedia from './components/media'
import './main.css'

global.isMobile = 'ontouchstart' in window || navigator.maxTouchPoints
global.isiOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream

global.trackEvent = (action, label) => {
    googleAnalyticsEvent({
        category: 'GIF Landing',
        action,
        label,
    })
}

global.Giphy = global.Giphy || {}
global.Giphy.renderMediaLanding = (el, data) => {
    Modernizr.on('webpanimation', isWebpSupported => {
        el.innerHTML = renderMedia(data, isWebpSupported)
    })
}
